import { useState, useEffect } from "react";
import { CircularProgress, GridLegacy as Grid } from "@mui/material";
import { makeStyles } from "@/compat/muiStyles";
import { useAppSelector } from "@/redux/hooks";
import useSiteAuditsLatest from "../hooks/queries/useSiteAuditsLatest";
import AuditsTableCard from "../components/AuditsTableCard";
import { useTracking } from "react-tracking";
import PageBase from "../../components/PageBase";
import PageTitle from "../components/PageTitle";
import SiteSelect from "../../components/SiteSelect";
import ActionsTableCard from "../components/ActionsTableCard";
import moduleAreas, { moduleIcons } from "../constants/moduleAreaConstants";
import { Alert } from "@mui/material";

const useStyles = makeStyles((theme) => ({
    tabsContainer: {
        flexGrow: 1,
    },
    tab: {
        minWidth: "unset",
        textTransform: "none",
    },
    grid: {
        marginBottom: theme.spacing(3),
    },
    titleGrid: {
        marginBottom: theme.spacing(2),
    },
}));

function Audit() {
    const { Track } = useTracking({ page: 'Audits' });
    const classes = useStyles();    
    const { selectedSite, activeAppId, appSiteIds } = useAppSelector(
        (state) => state.account
    );
    const [selectedAuditType, setSelectedAuditType] = useState("");    

    const latestAuditType = useSiteAuditsLatest({
        externalIds: selectedSite
            ? [selectedSite.externalId]
            : appSiteIds[activeAppId]
    });

    useEffect(() => {
        if (latestAuditType.data && !selectedAuditType) {
            setSelectedAuditType(latestAuditType.data);
        }
    }, [latestAuditType.data, selectedAuditType]);

    const pageContent = () => {
        if (latestAuditType.isLoading)
            return (
                <div className={classes.spinnerContainer}>
                    <CircularProgress color="primary" />
                </div>
            );
        else if (latestAuditType.isError)
            return <Alert severity="error">Error loading Audit Data</Alert>;
        else if (latestAuditType.isSuccess)
            return (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <ActionsTableCard moduleArea={moduleAreas.AUDIT} />
                    </Grid>
                    <Grid item xs={12}>
                        <AuditsTableCard />
                    </Grid>
                </Grid>
            );
    };

    return (
        <PageBase>
            <Track>
                <Grid
                    container
                    spacing={2}
                    justifyContent="space-between"
                    className={classes.titleGrid}
                >
                    <Grid item xs={12} md={9}>
                        <PageTitle
                            icon={moduleIcons.AUDIT}
                            title="Audit"  />
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <SiteSelect size="small" />
                    </Grid>
                </Grid>
                {pageContent()}
            </Track>
        </PageBase>
    );
}

export default Audit;
